function antiForgeryToken() {
    var service = window && window.$ && window.$.ServicesFramework && window.$.ServicesFramework();
    return service && service.getAntiForgeryValue() ? service.getAntiForgeryValue() : '';
}
document.addEventListener("DOMContentLoaded", function() {
    var baseUrl = window.location.origin;
    var token = antiForgeryToken();

    fetch(baseUrl+'/API/NewHorizonsIntlApiCore/OpenContentManageApi/GetTemplatesSettings', {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
        'RequestVerificationToken': token
    }
    })
    .then(function(response) {
        return response.json();
    })
    .then(function(jsonObj) {
        function hideElements() {
            jsonObj.Modules.forEach(function(title) {
                var elements = document.querySelectorAll(".octemplate a[title='" + title + "']");
                elements.forEach(function(element) {
                    element.parentElement.style.display = "none";
                });

                var options = document.querySelectorAll("select option");
                options.forEach(function(option) {
                    if (option.textContent === title) {
                        option.style.display = "none";
                    }
                });
            });

            var selects = document.querySelectorAll("select");
            selects.forEach(function(select) {
                var selectedOption = select.selectedOptions[0];
                if (selectedOption && selectedOption.style.display === "none") {
                    select.selectedIndex = -1; 
                    for (var i = 0; i < select.options.length; i++) {
                        if (select.options[i].style.display !== "none") {
                            select.selectedIndex = i;
                            break;
                        }
                    }
                }
            });
        }

        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length > 0) {
                    hideElements();
                }
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });

        hideElements();
    })
    .catch(function(error) {
        console.error('Error al cargar los datos del endpoint:', error);
    });
});